import React from 'react';
import { useQuery } from "react-query";
import { fetchElementsArborescence } from 'utils/queries';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

import MyAutocompleteVirtualize from './MyAutocompleteVirtualize';

const niveaux = [
    {
        niveau: 'G',
        label: 'Groupe'
    },
    {
        niveau: 'SG',
        label: 'Sous-Groupe'
    },
    {
        niveau: 'F',
        label: 'Famille'
    },
    {
        niveau: 'SF',
        label: 'Sous-Famille'
    },
]

const AddElementDialog = ({ open, onAddElement, onClose, parametreTypes }) => {

    /** Hook niveau */
    const [niveau, setNiveau] = React.useState('');

    /** Hook code */
    const [code, setCode] = React.useState(null);

    /** Hook paramètre */
    const [parametre, setParametre] = React.useState(null);

    /** Hook codes */
    const [codes, setCodes] = React.useState([]);

    /** Hook éléments Arborescence */
    const [elementsArbo, setElementsArbo] = React.useState(null);


    /** Handler Annuler */
    const handleCancel = () => {
        onClose();
    };

    /** Handler Ajouter */
    const handleAdd = () => {
        onClose();
        onAddElement(niveau, code.code, { valeur: parametre, libelle: parametreTypes[parametre] });
    };


    /** On récupère les éléments de l'arborescence */
    const query = useQuery("FetchElementsArborescence", () => fetchElementsArborescence(), { staleTime: "infinity" });

    React.useEffect(() => {
        if (!query.isLoading && !query.error && query.data) {
            setElementsArbo(query.data);
            //console.log(query.data);
        }
    }, [elementsArbo, query]);


    /** Mise à jour des codes après sélection d'un niveau */
    React.useEffect(() => {

        if (niveau !== '' && elementsArbo) {

            let codes;
            switch (niveau) {
                case "G":
                    codes = elementsArbo.g;
                    break;

                case "SG":
                    codes = elementsArbo.sg;
                    break;

                case "F":
                    codes = elementsArbo.f;
                    break;

                case "SF":
                    codes = elementsArbo.sf;
                    break;
            }
            // console.log(codes);
            setCodes(codes);
        }

    }, [niveau]);


    /** Handler du niveau */
    const handleChangeNiveau = (event) => {
        const {
            target: { value },
        } = event;

        setNiveau(value);
    }

    /** Handler du parametre sélectionné */
    const handleParametre = (event) => {
        let value = parseInt(event.target.value);

        if (!isNaN(value)) {
            setParametre(value);
        }
    }

    return (
        <Dialog open={open}>

            <DialogTitle>
                Ajout d'un élément paramétré :
            </DialogTitle>

            <DialogContent dividers>

                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Niveau</InputLabel>
                    <Select
                        id="niveaux"
                        value={niveau}
                        label="Niveau"
                        sx={{ width: 400, mb: 2 }}
                        onChange={handleChangeNiveau}
                    >
                        {niveaux.map((elem, index) => {

                            return (
                                <MenuItem
                                    key={index}
                                    value={elem.niveau}
                                >
                                    {elem.niveau} - {elem.label}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>

                <MyAutocompleteVirtualize
                    label="Code"
                    options={codes}
                    value={code}
                    onChange={(event, value) => setCode(value)}
                />


                <Typography component='div' variant="subtitle1">
                    <Box fontWeight='500' display='inline'>Paramètres :</Box>
                </Typography>

                <FormControl component="fieldset" sx={{ width: '100%', pl: 2 }}>
                    <RadioGroup
                        name="PARAMETRES"
                        value={parametre}
                        onChange={e => handleParametre(e)}
                        sx={{ mb: 1 }}
                    >
                        <Grid container
                            direction='column'
                            justifyContent="flex-start"
                            alignItems="flex-start"
                        >
                            {parametreTypes.map((param, index) => {
                                return (
                                    <Grid item xs={'auto'} key={index}>
                                        <FormControlLabel
                                            value={index}
                                            control={<Radio />}
                                            label={param}
                                        />
                                    </Grid>
                                );
                            })}

                        </Grid>
                    </RadioGroup>
                </FormControl>

            </DialogContent>

            <DialogActions>
                <Button
                    variant="standard"
                    color="primary"
                    onClick={handleCancel}
                >
                    Annuler
                </Button>

                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleAdd}
                    disabled={!niveau || !code || parametre == null}
                >
                    Ajouter
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default AddElementDialog;


